/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfGetZonesByParentIdListDto } from '../models/custom-result-of-list-of-get-zones-by-parent-id-list-dto';
import { CustomResultOfListOfGetZonesByTypeListDto } from '../models/custom-result-of-list-of-get-zones-by-type-list-dto';
import { CustomResultOfListOfZonesByParentIdForMapDto } from '../models/custom-result-of-list-of-zones-by-parent-id-for-map-dto';
import { CustomResultOfPaginatedListOfZoneWithPaginationDto } from '../models/custom-result-of-paginated-list-of-zone-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { CustomResultOfZoneDto } from '../models/custom-result-of-zone-dto';
import { zonesCreateGet } from '../fn/zones/zones-create-get';
import { ZonesCreateGet$Params } from '../fn/zones/zones-create-get';
import { zonesCreatePost } from '../fn/zones/zones-create-post';
import { ZonesCreatePost$Params } from '../fn/zones/zones-create-post';
import { zonesDelete } from '../fn/zones/zones-delete';
import { ZonesDelete$Params } from '../fn/zones/zones-delete';
import { zonesGetZoneById } from '../fn/zones/zones-get-zone-by-id';
import { ZonesGetZoneById$Params } from '../fn/zones/zones-get-zone-by-id';
import { zonesGetZoneCoordinates } from '../fn/zones/zones-get-zone-coordinates';
import { ZonesGetZoneCoordinates$Params } from '../fn/zones/zones-get-zone-coordinates';
import { zonesGetZonesAudit } from '../fn/zones/zones-get-zones-audit';
import { ZonesGetZonesAudit$Params } from '../fn/zones/zones-get-zones-audit';
import { zonesGetZonesByParentIdForMap } from '../fn/zones/zones-get-zones-by-parent-id-for-map';
import { ZonesGetZonesByParentIdForMap$Params } from '../fn/zones/zones-get-zones-by-parent-id-for-map';
import { zonesGetZonesByParentIdList } from '../fn/zones/zones-get-zones-by-parent-id-list';
import { ZonesGetZonesByParentIdList$Params } from '../fn/zones/zones-get-zones-by-parent-id-list';
import { zonesGetZonesByTypeList } from '../fn/zones/zones-get-zones-by-type-list';
import { ZonesGetZonesByTypeList$Params } from '../fn/zones/zones-get-zones-by-type-list';
import { zonesGetZonesWithPagination } from '../fn/zones/zones-get-zones-with-pagination';
import { ZonesGetZonesWithPagination$Params } from '../fn/zones/zones-get-zones-with-pagination';
import { zonesUpdateGet } from '../fn/zones/zones-update-get';
import { ZonesUpdateGet$Params } from '../fn/zones/zones-update-get';
import { zonesUpdatePut } from '../fn/zones/zones-update-put';
import { ZonesUpdatePut$Params } from '../fn/zones/zones-update-put';

@Injectable({ providedIn: 'root' })
export class ZonesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `zonesGetZonesAudit()` */
  static readonly ZonesGetZonesAuditPath = '/Zones/GetZonesAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesGetZonesAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonesGetZonesAudit$Response(params: ZonesGetZonesAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return zonesGetZonesAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesGetZonesAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonesGetZonesAudit(params: ZonesGetZonesAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.zonesGetZonesAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `zonesGetZonesWithPagination()` */
  static readonly ZonesGetZonesWithPaginationPath = '/Zones/GetZonesWithPagination';

  /**
   * Get Zones with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesGetZonesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonesGetZonesWithPagination$Response(params: ZonesGetZonesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfZoneWithPaginationDto>> {
    return zonesGetZonesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Zones with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesGetZonesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonesGetZonesWithPagination(params: ZonesGetZonesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfZoneWithPaginationDto> {
    return this.zonesGetZonesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfZoneWithPaginationDto>): CustomResultOfPaginatedListOfZoneWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `zonesGetZoneCoordinates()` */
  static readonly ZonesGetZoneCoordinatesPath = '/Zones/GetZoneCoordinates';

  /**
   * Get Zone Coordinates.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesGetZoneCoordinates()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZoneCoordinates$Response(params?: ZonesGetZoneCoordinates$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return zonesGetZoneCoordinates(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Zone Coordinates.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesGetZoneCoordinates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZoneCoordinates(params?: ZonesGetZoneCoordinates$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.zonesGetZoneCoordinates$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `zonesGetZonesByParentIdList()` */
  static readonly ZonesGetZonesByParentIdListPath = '/Zones/GetZonesByParentIdList';

  /**
   * Get list of Zones by ParentId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesGetZonesByParentIdList()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZonesByParentIdList$Response(params?: ZonesGetZonesByParentIdList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetZonesByParentIdListDto>> {
    return zonesGetZonesByParentIdList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of Zones by ParentId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesGetZonesByParentIdList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZonesByParentIdList(params?: ZonesGetZonesByParentIdList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetZonesByParentIdListDto> {
    return this.zonesGetZonesByParentIdList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetZonesByParentIdListDto>): CustomResultOfListOfGetZonesByParentIdListDto => r.body)
    );
  }

  /** Path part for operation `zonesGetZonesByParentIdForMap()` */
  static readonly ZonesGetZonesByParentIdForMapPath = '/Zones/GetZonesByParentIdForMap';

  /**
   * دریافت لیست مناطق برای نقشه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesGetZonesByParentIdForMap()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZonesByParentIdForMap$Response(params?: ZonesGetZonesByParentIdForMap$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfZonesByParentIdForMapDto>> {
    return zonesGetZonesByParentIdForMap(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست مناطق برای نقشه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesGetZonesByParentIdForMap$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZonesByParentIdForMap(params?: ZonesGetZonesByParentIdForMap$Params, context?: HttpContext): Observable<CustomResultOfListOfZonesByParentIdForMapDto> {
    return this.zonesGetZonesByParentIdForMap$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfZonesByParentIdForMapDto>): CustomResultOfListOfZonesByParentIdForMapDto => r.body)
    );
  }

  /** Path part for operation `zonesGetZonesByTypeList()` */
  static readonly ZonesGetZonesByTypeListPath = '/Zones/GetZonesByTypeList';

  /**
   * Get Zones by Type list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesGetZonesByTypeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZonesByTypeList$Response(params?: ZonesGetZonesByTypeList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetZonesByTypeListDto>> {
    return zonesGetZonesByTypeList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Zones by Type list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesGetZonesByTypeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZonesByTypeList(params?: ZonesGetZonesByTypeList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetZonesByTypeListDto> {
    return this.zonesGetZonesByTypeList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetZonesByTypeListDto>): CustomResultOfListOfGetZonesByTypeListDto => r.body)
    );
  }

  /** Path part for operation `zonesGetZoneById()` */
  static readonly ZonesGetZoneByIdPath = '/Zones/GetZoneById';

  /**
   * Get Zone by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesGetZoneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZoneById$Response(params?: ZonesGetZoneById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfZoneDto>> {
    return zonesGetZoneById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Zone by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesGetZoneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesGetZoneById(params?: ZonesGetZoneById$Params, context?: HttpContext): Observable<CustomResultOfZoneDto> {
    return this.zonesGetZoneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfZoneDto>): CustomResultOfZoneDto => r.body)
    );
  }

  /** Path part for operation `zonesCreateGet()` */
  static readonly ZonesCreateGetPath = '/Zones/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesCreateGet$Response(params?: ZonesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return zonesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesCreateGet(params?: ZonesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.zonesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `zonesCreatePost()` */
  static readonly ZonesCreatePostPath = '/Zones/Create';

  /**
   * Create Zone.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonesCreatePost$Response(params: ZonesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return zonesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Zone.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonesCreatePost(params: ZonesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.zonesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `zonesUpdatePut()` */
  static readonly ZonesUpdatePutPath = '/Zones/Update/{id}';

  /**
   * Update Zone.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonesUpdatePut$Response(params: ZonesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return zonesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Zone.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  zonesUpdatePut(params: ZonesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.zonesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `zonesUpdateGet()` */
  static readonly ZonesUpdateGetPath = '/Zones/Update';

  /**
   * Get Zone by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesUpdateGet$Response(params?: ZonesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfZoneDto>> {
    return zonesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Zone by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesUpdateGet(params?: ZonesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfZoneDto> {
    return this.zonesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfZoneDto>): CustomResultOfZoneDto => r.body)
    );
  }

  /** Path part for operation `zonesDelete()` */
  static readonly ZonesDeletePath = '/Zones/Delete';

  /**
   * Delete Zone.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `zonesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesDelete$Response(params?: ZonesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return zonesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Zone.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `zonesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  zonesDelete(params?: ZonesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.zonesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
